import TcModal from 'components/UI/Modal/TcModal';
import TcTab from 'components/UI/Tab/TcTab';
import BranchPackagingCreatePage from 'components/pages/dashboard/packaging/create/BranchPackagingCreatePage';
import { packaging } from 'global/Models/packagingModel';
import useHasAccess from 'global/helperFunctions/useHasAccess';
import { FC, memo, useCallback, useMemo, useState } from 'react';
import { BsBoxSeam } from 'react-icons/bs';

interface IOrderPersonPicker {
  close(): void;
  visible: boolean;
  setPackage: (_pack: packaging) => void;
}

const BranchOrderParcelPicker: FC<IOrderPersonPicker> = ({ close, visible, setPackage }) => {
  //states
  const [activeTab, setActiveTab] = useState('1');

  // Check access level at top-level
  const hasAccessLevel15 = useHasAccess();

  //functions
  const handleSelect = useCallback(
    (packaging: packaging) => {
      if (!packaging.isStandard && packaging.customerPackagingConfirmationTypeId != 1) return;
      setPackage(packaging);

      close();
    },
    [setPackage, close]
  );

  const tabs = useMemo(() => {
    const baseTabs = [
      {
        title: 'ثبت بسته جدید',
        icon: <BsBoxSeam />,
        key: '1',
        content: <BranchPackagingCreatePage handleSelect={handleSelect} noBack />,
      },
    ];

    return baseTabs;
  }, [hasAccessLevel15, handleSelect]);

  return (
    <TcModal title='انتخاب بسته' width={990} footer={false} onCancel={close} visible={visible}>
      <TcTab tabs={tabs} activeTab={activeTab} onChange={setActiveTab} />
      {/* <Tabs centered items={tcTabs} size='large' /> */}
    </TcModal>
  );
};

export default memo(BranchOrderParcelPicker);
